// Right-sizes images for fast loads: CDN resize params where supported, else our cached WebP proxy.
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// Re-point any /api/media/ URL to the CURRENT backend origin (host differs between preview and prod).
export function mediaUrl(url) {
  if (!url || typeof url !== "string") return url;
  const i = url.indexOf("/api/media/");
  if (i === -1) return url;
  return BACKEND ? BACKEND + url.slice(i) : url.slice(i);
}

export function cardImage(url, w = 600) {
  if (!url || typeof url !== "string") return url;
  url = mediaUrl(url);
  try {
    if (url.includes("/api/img?")) return url;
    if (url.includes("/api/media/")) return url.includes("?") ? url : `${url}?w=${w}`;
    if (url.includes("/api/")) return url;
    if (url.includes("/is/image/")) return `${url.split("?")[0]}?wid=${w}&qlt=75&fmt=webp&resMode=sharp2`;
    if (url.includes("images.unsplash.com")) return `${url.split("?")[0]}?auto=format&fit=crop&w=${w}&q=70`;
    if (url.includes("cdn.shopify.com")) return url.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "") + (url.includes("?") ? "&" : "?") + `width=${w}`;
    if (url.includes("media-cdn.tripadvisor.com")) return url.replace(/\/photo-[a-z]\//, w <= 550 ? "/photo-s/" : "/photo-w/");
    if (/^https?:\/\//.test(url) && BACKEND) return `${BACKEND}/api/img?w=${w}&u=${encodeURIComponent(url)}`;
  } catch (e) { /* noop */ }
  return url;
}

// Route <img> tags inside stored article HTML through the resizer and hide any that still fail.
export function optimizeHtmlImages(html, w = 600) {
  if (!html || typeof html !== "string") return html;
  return html.replace(/<img\b([^>]*?)\ssrc=(["'])([^"']+)\2([^>]*)>/gi, (m, pre, q, src, post) => {
    src = src.replace(/&amp;/g, "&");
    const fixed = cardImage(src, w);
    const fallback = fixed !== src ? `if(!this.dataset.r){this.dataset.r=1;this.src='${src.replace(/'/g, "%27")}'}else{this.style.display='none'}` : "this.style.display='none'";
    return `<img${pre} src=${q}${fixed}${q} loading="lazy" decoding="async" onerror="${fallback}"${post}>`;
  });
}
